import type { Resource } from '__types__/v1/models';

type ResourceRate = NonNullable<Resource['rates']>[number];

/** What a picker's row shows of a resource before anyone chose its fields. */
export const resourceRow = {
  name: (resource: Pick<Resource, 'full_name' | 'first_name' | 'last_name'>) =>
    resource.full_name ||
    [resource.first_name, resource.last_name].filter(Boolean).join(' ') ||
    null,

  initials: (resource: Pick<Resource, 'first_name' | 'last_name'>) =>
    (
      (resource.first_name?.trim()?.[0] ?? '') +
      (resource.last_name?.trim()?.[0] ?? '')
    ).toUpperCase() || '?',

  /** The first rate with an amount, in the order the resource keeps them. */
  firstRate: (resource: Pick<Resource, 'rates'>): ResourceRate | null =>
    [...(resource.rates ?? [])]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .find(rate => rate.amount != null) ?? null,

  locations: (resource: Pick<Resource, 'locations'>): string[] =>
    (resource.locations ?? [])
      .map(location => location.name?.trim())
      .filter((name): name is string => Boolean(name))
};
